module.exports = __webpack_public_path__ + "img/products-2.4a7f15ba.png";